const SWITCH_THEME = "SWITCH_THEME";

export default SWITCH_THEME;
